<template>
    <component
        :is="tag"
        :class="['o-path-step-otg', activeClass]"
        @click="onClick"
    >
        <div class="path-step-otg-index">
            {{ index + 1 }}
        </div>
        <span class="path-step-otg-title">
            <OStepText :step="step"/>
        </span>
        <span
            v-if="step.distance"
            class="path-step-otg-distance"
        >
            {{ step.distance }} m
        </span>
    </component>
</template>

<script>
import { computed } from '@vue/composition-api';

import OStepText from '../../unique-organisms/o-step-text/o-step-text';

export default {
    name: 'OPathStepOtg',
    components: {
        OStepText
    },
    props: {
        index: {
            type: Number,
            default: null
        },
        step: {
            type: Object,
            default: () => ({})
        },
        tag: {
            type: String,
            default: 'div'
        },
        isActive: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }) {
        const activeClass = computed(() => props.isActive ? 'path-step-otg-active' : null);

        function onClick() {
            emit('onClick', props.index)
        }

        return {
            activeClass,
            onClick
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />